import React, { Fragment } from "react";
import { Container, Row } from "reactstrap";
import { Breadcrumbs } from "../../AbstractElements";
import { Col } from "react-bootstrap";
import { useTranslation } from "react-i18next";
import TopSuggestion from "./TopSuggestion";

const ClinicAdminDashboard = () => {
  const { t } = useTranslation();

  return (
    <Fragment>
      <Breadcrumbs mainTitle={t("Dashboard")} parent={t("Dashboard")} title={t("Dashboard")} />
      <Container fluid={true}>
        <Row>
          <Col className="h-100">
            <TopSuggestion />
          </Col>
        </Row>
      </Container>
    </Fragment>
  );
};

export default ClinicAdminDashboard;
